import { PositionType } from '@/modules/accredited-establishments/api/types'
import { DEFAULT_ZOOM } from '@/modules/accredited-establishments/constants'

const defineZoom = (positionType: PositionType): number => {
  // TO DO: solve error 'key' is defined but never used @typescript-eslint/no-unused-vars
  //  { [key in PositionType]: number }
  const zoomMap = {
    [PositionType.CITY]: 13.5,
    [PositionType.NEIGHBORHOOD]: 15,
    [PositionType.STREET]: 16,
    [PositionType.BUILDING]: 16
  }

  return zoomMap[positionType] || DEFAULT_ZOOM
}

export { defineZoom }
